import { createNotification, fetch, key, trans } from "../../../lib/utils";
import React from "react";
import { Component } from "react";
import { Form, selectSubmission } from "@formio/react";
import { FormBuilder } from "@formio/react";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { FeatureToGeoJSON, showFeature } from "../../../lib/featureUtils";
import store from "../../../stores/store";
import { getLayerById, getMapProjection } from "../../map/mapUtils";
import ReadMoreAndLess from "react-read-more-less";
import { Vector as VectorSource } from "ol/source.js";
import GeoJSON from "ol/format/GeoJSON.js";
import moment from "moment";
import { Fill, Stroke, Style } from "ol/style";
import CircleStyle from "ol/style/Circle";

class FormioSubmissions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      submissions: [],
      username: null,
      selectedForm: props.form,
      selectedLayer: props.selectedLayer,
      password: null,
      formio: {
        url: props.selectedFormObject.configuration.url,
      },
      selectedFormObject: props.selectedFormObject,

      authentication: props.selectedFormObject.authentication?.url,
      loggedin: props.selectedFormObject?.token ? true : false,
      token: props.selectedFormObject?.token,
    };
  }

  componentDidMount() {
    this.getForms();
  }

  getForms() {
    let _this = this;
    fetch(
      window["appConfig"]()["api"](
        "?proxy=formio&contenttype=".concat(
          "application/json",
          "&url=",
          this.state.formio.url,
          "submission",
          "?limit=10000000&sort=created"
        )
      ),
      "GET",
      { "x-jwt-token": this.state.token },
      null,
      (resp) => {
        let _data = resp.data;

        _data?.forEach((el) => {
          if (
            el.data[
              this.props.selectedFormObject?.configuration?.featureProperty
            ] &&
            store.getState().forms.selectedSubmission !== el._id
          ) {
            try {
              let _feature = new GeoJSON().readFeature(
                JSON.parse(
                  el.data[
                    this.props.selectedFormObject?.configuration
                      ?.featureProperty
                  ]
                )
              );

              _feature.setId(el._id);

              _feature.setProperties(el.data);

              getLayerById(_this.state.selectedLayer)
                .getSource()
                .addFeature(_feature);
            } catch (e) {
              console.log(e);
            }
          }
        });

        if (_this.state.selectedFormObject?.sldRules) {
          getLayerById(_this.state.selectedLayer).setStyle(function (feature) {
            let styleObject = _this.state.selectedFormObject?.sldRules(feature);

            if (styleObject) {
              return new Style({
                fill: new Fill({
                  color: styleObject?.fill?.color
                    ? styleObject.fill.color
                    : "red",
                }),
                stroke: new Stroke({
                  color: styleObject?.stroke?.color
                    ? styleObject.stroke.color
                    : "red",
                  lineDash: [4],
                  width: 2,
                }),
                image: new CircleStyle({
                  radius: 10,
                  stroke: new Stroke({
                    color: styleObject?.circle?.stroke?.color
                      ? styleObject.circle.stroke.color
                      : "red",
                  }),
                  fill: new Fill({
                    color: styleObject?.circle?.fill?.color
                      ? styleObject.circle.fill.color
                      : "red",
                  }),
                }),
              });
            }
            return feature.getStyle();
          });
        }

        _this.setState({ loaded: true, submissions: resp.data });
      }
    );
  }

  deleteForm(submission) {
    let _this = this;

    window["primaryModal"].setState({
      show: true,
      size: "default",
      title: trans("Delete confirmation"),
      body: (
        <div className="p-2">
          {trans("Are you sure you want to remove submission")}{" "}
          <strong>"{submission}"</strong>
        </div>
      ),
      footer: [
        <button
          className="btn btn-sm btn-link"
          onClick={(e) => {
            window["primaryModal"].setState({
              show: false,
            });
          }}
        >
          {trans("Cancel")}
        </button>,
        <button
          className="btn btn-sm btn-danger text-white"
          onClick={(e) => {
            fetch(
              window["appConfig"]()["api"](
                "?proxy=formio&contenttype=".concat(
                  "application/json",
                  "&url=",
                  _this.state.formio.url,
                  "submission/",
                  submission
                )
              ),
              "DELETE",
              { "x-jwt-token": _this.state.token },
              null,
              (resp) => {
                _this.getForms();
              }
            );

            window["primaryModal"].setState({
              show: false,
            });
          }}
        >
          {trans("Delete")}
        </button>,
      ],
    });
  }

  login(submission) {
    console.log(submission);
    let _this = this;
    fetch(
      window["appConfig"]()["api"](
        "?proxy=formio&contenttype=".concat(
          "application/json",
          "&url=",
          this.state.authentication
        )
      ),
      "POST",
      {},
      {
        data: {
          email: submission.data.email,
          password: submission.data.password,
        },
      },
      (resp) => {
        if (resp.headers) {
          if (resp.headers["x-jwt-token"]) {
            _this.setState({
              token: resp.headers["x-jwt-token"],
              loggedin: true,
              username: submission.data.email,
            });

            store.dispatch({
              type: "forms/update",
              payload: {
                form: _this.state.selectedForm,
                property: "token",
                value: resp.headers["x-jwt-token"],
              },
            });
          }
        }
      }
    );
  }

  loginForm() {
    return (
      <div className="mt-2 p-2 me-3">
        <div className="ps-2 mt-2 color-get-blue strong border-bottom d-block pb-2">
          {trans("Login")}
        </div>

        <Form
          form={{
            title: "Login",
            display: "form",
            components: [
              {
                label: trans("Username"),
                key: "email",
                type: "email",
              },
              {
                label: trans("Password"),
                key: "password",
                type: "password",
              },
              {
                label: trans("Login"),
                key: "submit",
                type: "button",
                action: "submit",
                customClass: "btn btn-sm text-white ms-0",
              },
            ],
          }}
          onSubmit={this.login}
        />
        {/* <input
          type="text"
          className="form-control"
          placeholder={trans("Username")}
          value={this.state.username}
          onChange={(e) => {
            this.setState({ username: e.target.value });
          }}
        ></input>
        <input
          type="password"
          className="form-control mt-2"
          placeholder={trans("Password")}
          value={this.state.password}
          onChange={(e) => {
            this.setState({ password: e.target.value });
          }}
        ></input>
        <div className="mt-2">
          <button
            type="button"
            className="btn btn-sm btn-secondary text-white me-2"
            onClick={() => {
              this.setState({ username: null, password: null });
            }}
          >
            {trans("Clear")}
          </button>
          <button
            type="button"
            className="btn btn-sm btn-primary text-white"
            onClick={this.login}
          >
            {trans("Login")}
          </button> 
        </div>*/}
      </div>
    );
  }

  render() {
    if (this.state.loaded) {
      return (
        <div className="mt-2 p-2 me-3">
          <div className="mt-2">
            {this.state.authentication && !this.state.loggedin
              ? this.loginForm()
              : this.state.submissions?.map((el, idx) => {
                  return (
                    <div className="card mt-3 ">
                      <div
                        className="  me-2 mt-1 d-flex ps-3 pt-2"
                        role="button"
                      >
                        <span className="color-get-blue w-100 ">
                          <small>
                            {trans("Submission").concat(" ", el._id)}
                          </small>
                        </span>
                        <i
                          className="fas fa-pencil-alt color-black fa-sm me-2"
                          onClick={() => {
                            store.dispatch({
                              type: "forms/selectedTab",
                              payload: "form",
                            });
                            store.dispatch({
                              type: "forms/feature/select/submission",
                              payload: el._id,
                            });

                            if (
                              el.data[
                                this.props.selectedFormObject?.configuration
                                  ?.featureProperty
                              ]
                            ) {
                              store.dispatch({
                                type: "forms/feature/select",
                                payload: getLayerById(this.state.selectedLayer)
                                  .getSource()
                                  .getFeatureById(el._id),
                              });

                              let feature = JSON.parse(
                                el.data[
                                  this.props.selectedFormObject?.configuration
                                    ?.featureProperty
                                ]
                              );

                              feature.projection = getMapProjection();

                              showFeature(feature);
                            } else {
                              store.dispatch({
                                type: "forms/feature/select",
                                payload: null,
                              });
                            }
                          }}
                        ></i>
                        <i
                          className="fas fa-trash-alt color-black fa-sm"
                          onClick={() => {
                            this.deleteForm(el._id);
                          }}
                        ></i>
                      </div>
                      <div className="card-body">
                        <div className="mb-2 text-secondary">
                          <small className="d-block">
                            {trans("Created")}:{" "}
                            {moment(el.created).format("DD/MM/YYYY HH:mm:ss")}
                          </small>
                          <small className="d-block">
                            {trans("Modified")}:{" "}
                            {moment(el.modified).format("DD/MM/YYYY HH:mm:ss")}
                          </small>
                        </div>
                        <ReadMoreAndLess
                          className="read-more-content"
                          charLimit={50}
                          readMoreText={trans("more")}
                          readLessText={trans("less")}
                        >
                          {Object.keys(el.data)?.map((dd) => {
                            return (
                              <div
                                className="w-75"
                                style={{ overflowWrap: "anywhere" }}
                              >
                                {dd.concat(":", " ", el.data[dd])}
                              </div>
                            );
                          })}
                        </ReadMoreAndLess>
                        {el.data[
                          this.props.selectedFormObject?.configuration
                            ?.featureProperty
                        ] ? (
                          <div className=" text-end mt-4">
                            {/* <button
                              className="btn btn-white btn-sm border me-2"
                              onClick={() => {
                                // getFeatureInfo(
                                //   el.event,
                                //   layers,
                                //   sources,
                                //   store
                                // );
                              }}
                            >
                              <span className="small">
                                {trans("Get feature info")}
                              </span>
                            </button> */}
                            <button className="btn btn-success btn-sm">
                              <span
                                className="text-white small"
                                onClick={() => {
                                  let feature = JSON.parse(
                                    el.data[
                                      this.props.selectedFormObject
                                        ?.configuration?.featureProperty
                                    ]
                                  );

                                  feature.projection = getMapProjection();

                                  showFeature(feature);
                                }}
                              >
                                {trans("Show Feature")}
                              </span>
                            </button>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  );
                })}
          </div>
        </div>
      );
    }
    return (
      <span className="badge bg-info text-primary m-1 p-2">
        {trans("Please wait to load the form")}
      </span>
    );
  }
}

export default FormioSubmissions;
